module.exports = __webpack_public_path__ + "static/img/footer_bg.ec0b047.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/footer_bg.png
// module id = 7LeT
// module chunks = 9